/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleList,
    AdminGroupSaleListFromJSON,
    AdminGroupSaleListFromJSONTyped,
    AdminGroupSaleListToJSON,
} from './AdminGroupSaleList';

/**
 * 
 * @export
 * @interface AdminGroupSaleListResponse
 */
export interface AdminGroupSaleListResponse {
    /**
     * 
     * @type {Array<AdminGroupSaleList>}
     * @memberof AdminGroupSaleListResponse
     */
    groupSales: Array<AdminGroupSaleList>;
}

export function AdminGroupSaleListResponseFromJSON(json: any): AdminGroupSaleListResponse {
    return AdminGroupSaleListResponseFromJSONTyped(json, false);
}

export function AdminGroupSaleListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupSales': ((json['groupSales'] as Array<any>).map(AdminGroupSaleListFromJSON)),
    };
}

export function AdminGroupSaleListResponseToJSON(value?: AdminGroupSaleListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupSales': ((value.groupSales as Array<any>).map(AdminGroupSaleListToJSON)),
    };
}

